export enum DocumentType {
  WrittenNotificationAndOptOutRequirementsAndTimelineParentForm = '1',
  NotificationOfPotentialEligibilityToTheCommitteeOnPreschoolSpecialEducation = '2',
  ConsentForATransitionConference = '3',
  FormForParentReferralToTheCommitteeOnPreschoolSpecialEducation = '4',
  ConsentForEITransmittalOfEIPEvaluationsAndRecords = '5',
  EIEvaluations = '6',
  IndividualizedFamilyServicePlanIFSP = '7',
  EIProgressNotes = '8',
  OtherEIDocumentation = '9',
  NYCEarlyInterventionProgramConsentToReleaseObtainInformation = '10',
  BirthCertificate = '11',
  CourtLegalDocuments = '12',
  MedicalFormsInformation = '13',
  OtherFormsWithPersonalInformationAboutChildFamily = '14',
  Other = '15',
  Attendance = '16',
  DEP1 = '17',
  ConsentForInitialEvaluation = '18',
  ConsentForInitialProvisionOfServices = '19',
  PreschoolAcceptanceLetter = '20',
  CentralAuditoryProcessingDisorderAssessment = '21',
  CustomObservationAssessment = '22',
  FeedingAssessment = '23',
  ClassroomObservation = '24',
  SpeechAndLanguageAssessment = '25',
  HearingScreeningAssessment = '26',
  OrientationAndMobilityAssessment = '27',
  VisionScreeningAssessment = '28',
  GenericAssessment = '29',
  PsychologicalAssessment = '30',
  PsychologicalUpdate = '31',
  PsychologicalEvaluationAssessment = '32',
  PsychoeducationalAssessment = '33',
  PrePsychoeducationalAssessment = '34',
  AdaptedPhysicalEducationAssessment = '35',
  AssistiveTechnologyAssessment = '36',
  OccupationalTherapyAssessment = '37',
  EducationalEvaluationReport = '38',
  FunctionalBehaviorAssessmentFBA = '39',
  LevelIVocationalAssessmentTeacher = '40',
  LevelIVocationalAssessmentParentGuardian = '41',
  LevelIVocationalAssessmentStudent = '42',
  PhysicalTherapyAssessment = '43',
  PhysicalTherapyTeacherAssessment = '44',
  PhysicalTherapyParentAssessment = '45',
  OccupationalTherapyTeacherAssessment = '46',
  OccupationalTherapyParentAssessment = '47',
  SocialHistoryEvaluationAssessment = '48',
  SocialHistoryEvaluationUpdate = '49',
  AudiologicalAssessment = '50',
  AssistiveTechnologyEvaluationDistrict75 = '51',
  PsychiatricAssessment = '52',
  NeuropsychologicalAssessment = '53',
  NeurologicalAssessment = '54',
  OtherAssessment = '55',
  UserEvent = '56',
  ConsentForWaiverOfIEPMeeting = '57',
  Other1 = '58',
  Other2 = '59',
  Other3 = '60',
  Other4 = '61',
  STAC = '62',
  PartiallyServedNotice = '63',
  RefusalOfRequestToConductInitialEvaluation = '64',
  NoticeOfInitialReferral = '65',
  PreschoolPWNIR = '66',
  SocialHistoryMeeting = '67',
  GenEdInterventionMeeting = '68',
  ParentAndPrincipalWrittenAgreement = '69',
  RequestForReevaluation = '70',
  AdditionalReevaluation = '71',
  RefusalOfReevaluation = '72',
  RefusalOfAdditionalReevaluation = '73',
  MandatedThreeYearReevaluation = '74',
  ParentWaiverOfMandatedThreeYearReevaluation = '75',
  RequestForAdditionalAssessments = '76',
  SocialHistoryPackage = '77',
  HIPAA = '78',
  PreschoolEvaluationSummary = '79',
  ConsentForAdditionalAssessments = '80',
  AdditionalReevaluationConsent = '81',
  WithdrawalInitialReferralFromSpecialEducationProcess = '82',
  Initial = '83',
  ReevaluationAnnual = '84',
  PlacementWithdrawalForm = '85',
  NoticeOfTermination = '86',
  FinalNoticeOfWithdrawalFromTheEvalInitial = '87',
  PWNIneligibility = '88',
  PWNDeclassification = '89',
  IEPDocument = '90',
  IneligibilityLetter = '91',
  Declassification = '92',
  PreschoolLocationLetter = '93',
  VarianceNotification = '94',
  PhysicalExamination = '95',
  UseOfElectronicMail = '96',
  HomeLanguageIdentificationSurvey = '97',
  TemporaryHousingQuestionnaire = '98',
  EthnicityIdentification = '99',
  ChildCustodyProof = '100',
  ChildageProofDocument = '101',
  RequestToSharePersonallyIdentifiableInformation = '102',
  BehavioralInterventionPlan = '103',
  NoticeOfMeetingIEP = '104',
  ProgressReport = '105',
  DocumentsRelatedToPreschoolPlacement = '106',
  DocumentsRelatedToPreschoolReferral = '107',
  DocumentsRelatedToPreschoolOther = '108',
  DocumentsRelatedToPreschoolRelatedServices = '109',
  DocumentsRelatedToPreschoolIEP = '110',
  DocumentsRelatedToPreschoolAssessment = '111',
  ConsentForTransitionConferenceDocument = '112',
  ParentWithdrawalOfConsent = '113',
  MemberExcusedForm = '114',
  TwelveMonthSchoolYearConsent = '115',
  VarianceRequest = '116',
  NotApplicable = '999',
  ParentNoticeOfIntentParentallyPlaced = '124',
  ParentNoticeOfIntent = '134',
  CoverLetterForSchool = '135',
  MedicaidParentalConsent = '138',
  NPSReferralCBSTUser = '161',
  NPSReferralNPSUser = '162',
  ConsentForInitialProvisionParentallyPlaced = '125'

}
